import axiosInstance from "../../axios";

const state = {
    dashboardData: {},
    dashboardError: null,
};

const getters = {
    dashboardData: state => state.dashboardData,
    dashboardError: state => state.dashboardError,
};

const mutations = {
    setDashboardData(state, value) {
        state.dashboardData = value;
    },

    setDashboardError(state, msg) {
        state.dashboardError = msg;
    },
};

const actions = {
    async getDashboardData({ commit }) {
        try {
            const result = await axiosInstance({ requiresAuth: true }).get("/customer/dashboard"); 
            commit('setDashboardData', result);
            commit("setDashboardError", null);
        } catch (error) {
            commit("setDashboardError", error.response.data.message);
            throw error;
        }
    },
};



export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
